<template>
    <div class="main-header-center ms-3 d-none d-lg-block">
        <input type="text" id="myInput" @keyup="runSearch()" placeholder="Rechercher ..." title="Type in a name" class="form-control">
        <!-- <div style="border: 1px solid #1E6E53; padding: 1%; text-align: center; display: none" id="not_found_text">
            Aucun élément trouvé
        </div> -->
    </div>
 </template>
 
 <script>
     import helpers from "../helpers/helpers";
 
     export default {
         name: "SearchInputAll",
         mixins: [helpers(this)],
         computed: {
             user() {
                 return this.$store.getters['auth/loggedAs'];
             }
         },
         methods: {
             runSearch(){
                 this.myFunction1();
                 this.myFunction2();
                 this.myFunction3();
                 this.myFunction4();
                 this.myFunction5();
             }
         }
     }
 </script>
 
 <style scoped>
 
 </style>